import EngineModule                  from '../../../EngineModule';
import { NS as StandingFurnitureNS } from '../../../components/customers/standing/StandingFurniture/StandingFurniture';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'standing-furniture',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	insertionPath :    'K',
	generateComponentConfiguration() : StandingFurnitureNS.Configuration {
		return {};
	},
	async initialize() {
	}
});
